import { Typography } from '@mui/material';
import Modal from 'components/Common/Modal';
import Button from 'components/Common/Button';
import { DeleteModalProps } from 'types/modal';

const DeleteModal = ({ onClose, isOpen, title, description, loading, onDelete, children }: DeleteModalProps) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} modalTitle={title}>
            <>
                <Typography sx={{ fontSize: 18, my: 2, color: '#1F2937', fontWeight: 400 }}>
                    {description && description}
                    {children && children}
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                    <Button backgroundColor="white" onClick={onClose} width="45%" title="Cancel" />
                    <Button
                        color="error"
                        variant="contained"
                        backgroundColor="#D70000"
                        loading={loading}
                        onClick={onDelete}
                        width="45%"
                        title="Delete"
                    />
                </div>
            </>
        </Modal>
    );
};

export default DeleteModal;
